import { TRUST_STATS } from "../../data/site";

export const TrustBar = () => {
    return (
        <section
            data-testid="trust-bar"
            className="bg-ink text-bone border-y border-ink"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
                {TRUST_STATS.map((s, idx) => (
                    <div
                        key={s.label}
                        data-testid={`trust-stat-${idx}`}
                        className="reveal"
                        style={{ transitionDelay: `${idx * 80}ms` }}
                    >
                        <div className="font-heading text-3xl md:text-5xl font-extrabold tracking-tight text-ember">
                            {s.value}
                        </div>
                        <div className="mt-2 text-sm font-semibold uppercase tracking-wider">
                            {s.label}
                        </div>
                        <div className="text-xs text-bone/60 mt-1">{s.sub}</div>
                    </div>
                ))}
            </div>
        </section>
    );
};
